import { IActionHandlerParams } from "../types";

export const saveSQ = (_: string, parameters?: IActionHandlerParams) => {
  if (
    parameters?.gridState?.query &&
    parameters?.dispatch &&
    parameters?.gridState?.query?.isTemp
  ) {
    return parameters.dispatch({ kind: "save", query: parameters.gridState.query });
  }
};
